const initialState = {
  id: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "SET_ABANDONED_CART":
      return { ...state, id: payload };

    default:
      return state;
  }
};
